<ng-container *transloco="let t;">
  <h2 mat-dialog-title>Confirmation</h2>
  <mat-dialog-content>
    <p>{{ data.message }}</p>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-stroked-button color="primary" (click)="onCancel()" style="background-color: white;">CANCEL</button>
    <button mat-flat-button color="primary" (click)="onConfirm()">OK</button>
  </mat-dialog-actions>
</ng-container>